export default "__VITE_ASSET__as4mje$l__"